import React, { useEffect, useState, useContext } from 'react'
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import OpenInNewSharpIcon from '@mui/icons-material/OpenInNewSharp';
import ReactTable from 'components/common/ReactTable';
import { useForm, Controller } from 'react-hook-form';
import SearchableDropdown from 'components/common/SearchableDropdown';
import ReactDatePicker from 'components/common/ReactDatePicker';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { checkModulePermission } from 'components/common/helper-function/ModulePermissionCheck';
import './report.css'
import { getListOfDepartment, getListOfVisitortype } from 'services/adminmoduleService'
import { errorMessage } from 'components/common/helper-function/catchErrorMessage';
import { summaryreportlist } from 'services/reportsService'
import moment from 'moment';
import { loaderContext } from 'context/Context';
import { toast } from 'react-toastify';
import toastConfig from 'components/configuration/toast-config';




function SummaryReport() {

    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    const { isLoading, setIsLoading } = useContext(loaderContext)
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [summarydata, setSummaryData] = useState([]);
    const [departmentOption, setDepartmentOption] = useState([]);
    const [visitorTypeOption, setVisitorTypeOption] = useState([]);
    // const [dateRange, setDateRange] = useState([null, null]);
    // const [startDate, endDate] = dateRange;

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);


    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
        control,
        setValue,
        setError,
        clearErrors,
        watch
    } = useForm();

    useEffect(async () => {
        checkModulePermission("Summary Report")
        setIsLoading(true)
        try {
            const { data } = await getListOfDepartment()
            const { data: visitortype } = await getListOfVisitortype()
            const { data: summarylist } = await summaryreportlist({})
            setDepartmentOption(data?.data?.map((depart) => ({ label: depart?.name, value: depart?.id })))
            setVisitorTypeOption(visitortype?.data?.map((visitor) => ({ label: visitor?.name, value: visitor?.id })))
            setSummaryData(summarylist?.data)
        } catch (error) {
            errorMessage(error)
        }
        setIsLoading(false)
    }, [])



    const columns = [

        {
            Header: t('summaryreport.summaryreporttable.department'),
            accessor: 'department_name',
            Cell: ({ row }) => {
                return row?.original?.department_name ? row?.original?.department_name : '--'
            }
        },
        {
            Header: t('summaryreport.summaryreporttable.loggedin'),
            accessor: 'logged_in',
            Cell: ({ row }) => {
                return row?.original?.logged_in ? row?.original?.logged_in : '0'
            }
        },
        {
            Header: t('summaryreport.summaryreporttable.loggedout'),
            accessor: 'logged_out',
            Cell: ({ row }) => {
                return row?.original?.logged_out ? row?.original?.logged_out : '0'
            }
        },
        {
            Header: t('summaryreport.summaryreporttable.date'),
            accessor: 'date',
            Cell: ({ row }) => {
                return row?.original?.date ? moment.utc(row?.original?.date).local().format(process.env.REACT_APP_FILTER_DATE) : '--'
            }
        },

    ];

    const onSubmit = async (summarydata) => {
        console.log("summarydata", summarydata)
        setIsLoading(true)

        if (summarydata?.department_id || summarydata?.visitor_type || (startDate && endDate)) {
            try {
                summarydata.department_id = summarydata.department_id?.value
                summarydata.visitor_type = summarydata.visitor_type?.value
                if (startDate && endDate) {
                    summarydata.date_range = `${moment(startDate).format(process.env.REACT_APP_FILTER_DATE)}-${moment(endDate).format(process.env.REACT_APP_FILTER_DATE)}`;
                }

                const { data } = await summaryreportlist(summarydata)
                setSummaryData(data?.data)

            } catch (e) {
                if (e.response.data) {
                    if (Array.isArray(e.response.data.message)) {
                        e.response.data.message.map(errors => toast.error(errors, toastConfig))
                    } else {
                        toast.error(e.response.data.message, toastConfig)
                    }
                } else {
                    toast.error(e.message, toastConfig)
                }
            }
        }
        setIsLoading(false)

    };

    const downloadPDF = () => {
        const docDefinition = {
            pageOrientation: 'landscape',
            pageSize: { width: 700, height: 600 },
            content: [
                { text: 'User Data', style: 'header' },
                { text: '\n' },
                {
                    table: {
                        headerRows: 1,
                        widths: Array.from({ length: columns.length }, () => 'auto'),
                        body: [
                            columns.map((column) => column.Header),
                            ...summarydata.map((row) => columns.map((column) => row[column.accessor])),
                        ],
                    },
                },
            ],
            defaultStyle: {
                actionHeader: false,
            },
            styles: {
                header: {
                    fontSize: 18,
                    bold: true,
                },
            },
        };

        const pdfDocGenerator = pdfMake.createPdf(docDefinition);
        pdfDocGenerator.download('summary_data.pdf');
    };

    const downloadCSV = () => {
        const csvData = [
            columns.map((column) => column.Header),
            ...summarydata.map((row) => columns.map((column) => row[column.accessor])),
        ]
            .map((row) => row.join(','))
            .join('\n');

        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
        saveAs(blob, 'summary_data.csv');
    };


    return (
        <div className="row g-3 mb-3">
            {/* <div className=""> */}
            <div className="card overflow-hidden mb-3 col-sm-12 col-md-12 col-lg-9 data-table" style={{ height: "fit-content" }}>
                <div className="card-header">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-4 heading-text">
                            <h3 className="heading-color fw-600 mb-0">
                                {t('summaryreport.visitorsummaryheading')}
                            </h3>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-8 table-btn" >
                            <button
                                className="btn btn-primary btn-sm float-end"
                                onClick={() => downloadPDF()}
                            >
                                <OpenInNewSharpIcon />
                                {/* <FontAwesomeIcon icon="plus" /> */}
                                <span className="ms-1 d-sm-inline ">
                                    {t('summaryreport.exportpdfbtn')}
                                </span>
                            </button>

                            <button
                                className="btn mx-1 btn-primary btn-sm float-end"
                                onClick={() => downloadCSV()}
                            >
                                <OpenInNewSharpIcon />
                                {/* <FontAwesomeIcon icon="plus" /> */}
                                <span className="ms-1 d-sm-inline ">
                                    {t('summaryreport.exportcsvbtn')}
                                </span>
                            </button>
                        </div>

                        <div className="col-12">
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="card-body pt-0">
                    <ReactTable
                        columns={columns}
                        data={summarydata}
                        pageSizeOption={[5, 10, 15, 20]}
                        headerClass="btn-primary"
                        isSearchBoxVisible
                        ispaginationvisible={true}
                    />
                </div>
            </div>


            <div className='card overflow-hidden mb-3 col-sm-12 col-md-12 col-lg-2 filter-table' style={{ padding: "0rem .8rem 0rem .8rem", height: "fit-content" }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='row' style={{ backgroundColor: "rgb(247, 247, 247)", paddingTop: ".8rem", height: "3rem", color: "black", marginBottom: '1rem' }}>
                        <span>{t('summaryreport.filterheading')}</span>
                    </div>

                    <div className="form-group col-12 mb-3">
                        <label>
                            {t('summaryreport.filterform.department')}
                        </label>
                        <Controller
                            name="department_id"
                            control={control}
                            // rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <SearchableDropdown
                                    value={value}
                                    onChange={onChange}
                                    options={departmentOption}
                                    hasError={errors.department_id}
                                // placeholder={t('suppliercontractor.createsupplierplaceholder.selectcompanytype')}
                                />
                            )}
                        />
                        {/* {errors.department_id && (
                            <small>
                                {errors.department_id.type === 'required' && (
                                    <span className="text-danger">
                                        {t('summaryreport.error.departmenterror')}
                                    </span>
                                )}
                            </small>
                        )} */}
                    </div>
                    <div className="form-group col-12 mb-3">
                        <label>
                            {t('summaryreport.filterform.visitortype')}
                        </label>
                        <Controller
                            name="visitor_type"
                            control={control}
                            // rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <SearchableDropdown
                                    value={value}
                                    onChange={onChange}
                                    options={visitorTypeOption}
                                    hasError={errors.visitor_type}
                                    placeholder={t('summaryreport.placeholder.visitortype')}
                                />
                            )}
                        />
                        {/* {errors.visitor_type && (
                            <small>
                                {errors.visitor_type.type === 'required' && (
                                    <span className="text-danger">
                                        {t('summaryreport.error.visitortypeerror')}
                                    </span>
                                )}
                            </small>
                        )} */}
                    </div>
                    <div className="form-group col-12 mb-3">
                        <label>
                            {t('summaryreport.filterform.daterange')}
                        </label>
                        <Controller
                            name="date_range"
                            control={control}
                            // rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <>
                                    {/* <ReactDatePicker
                                    value={value}
                                    // onChange={onChange}
                                    onChange={(update) => {
                                        setDateRange(update);
                                    }}
                                    placeholder={t(
                                        'summaryreport.placeholder.date'
                                    )}
                                    hasErrors={errors.date_range}
                                    dateFormat="dd/MM/yyyy"
                                    startDate={startDate}
                                    endDate={endDate}
                                    selectsRange={true}
                                // isClearable={true}
                                /> */}
                                    <ReactDatePicker
                                        selected={startDate}
                                        value={startDate}
                                        onChange={(date) => setStartDate(date)}
                                        placeholder={t('summaryreport.placeholder.startdate')}
                                        dateFormat="dd/MM/yyyy"
                                        selectsStart
                                        startDate={startDate}
                                        endDate={endDate}
                                        maxDate={endDate || undefined}
                                    />
                                    {/* <span className="mx-2">-</span> */}
                                    <br />
                                    <ReactDatePicker
                                        selected={endDate}
                                        value={endDate}
                                        onChange={(date) => setEndDate(date)}
                                        placeholder={t('summaryreport.placeholder.enddate')}
                                        dateFormat="dd/MM/yyyy"
                                        selectsEnd
                                        startDate={startDate}
                                        endDate={endDate}
                                        minDate={startDate || undefined}
                                    />

                                </>
                            )}
                        />
                        {/* {errors.date_range && (
                            <small>
                                {errors.date_range.type === 'required' && (
                                    <span className="text-danger">
                                        {t('summaryreport.error.dateerror')}
                                    </span>
                                )}
                            </small>
                        )} */}
                    </div>



                    <div className="text-start col-12">
                        <div className="mb-3 mt-4 text-start">
                            <button type="submit" className="col-lg-12 btn btn-primary me-1">
                                {t('summaryreport.filterform.filterbtn')}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            {/* </div> */}
        </div>
    )
}

export default SummaryReport